// App.js

import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom"; // Don't import BrowserRouter here
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Toaster } from "react-hot-toast";
import { Calculate } from "./components/Calculate";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Toaster
        toastOptions={{
          style: {
            fontSize: "18px", // Increases the font size
            padding: "7px", // Adds padding to the toast
            background: "#5da4fb", // Custom background color
            color: "#fff", // Custom text color
          },
        }}
      />
      <Navigation />

      <Routes>
        {" "}
        {/* Define your routes */}
        <Route
          path="/"
          element={
            // Define the route for home page
            <>
              <Header />
              <Features />
              <About />
              <Services />
              <Testimonials data={landingPageData.Testimonials} />
              <Team data={landingPageData.Team} />
              <Contact />
            </>
          }
        />
        {/* You can define other routes here */}
        <Route path="/cost-CB" element={<Calculate page={'CB'} />} />
        <Route path="/cost-TPT" element={<Calculate page={'TPT'} />} />
        <Route path="/cost-HLB" element={<Calculate page={'HLB'} />} />
      </Routes>
    </div>
  );
};

export default App;
